/**
 * @Description 奥乐齐小区数据统计
 */

import { FC, useMemo } from 'react';
import { Modal } from 'antd';
import { useMethods } from '@lhb/hook';
import { fixNumber } from '@/common/utils/ways';
// import cs from 'classnames';
// import styles from './entry.module.less';
import V2Table from '@/common/components/Data/V2Table';
import { communityAgglistV2 } from '@/common/api/spotevaluation';
import { toCommunityAggregateRows } from './communityAggregate';
import { SpotTypeEnum, getTitleSearchTypeNameByValue, getRadiusNameBySearchTypeAndValue } from '@/views/spotevaluation/pages/index/ts-config';

interface ALQStatisticsProps {
  modalData: any;
  close: () => void;
};

const ALQStatistics: FC<ALQStatisticsProps> = ({
  modalData,
  close
}) => {
  const { open, name, radius, detail, drawerData } = modalData || {};

  /**
   * 范围的显示：
   *
   * 街边店与抽屉左上角标题最后部分保持一致的范围文案
   * 半径：1km；步行/骑行/驾车 + 时间 tab：步行10分钟；步行/骑行/驾车 + 距离 tab：步行3km
   *
   * 商场店显示周边查询半径（老处理）
   *
   */
  const titleSearchTypeName = useMemo(() => {
    return getTitleSearchTypeNameByValue(detail?.poiSearchType) || '';
  }, [detail?.poiSearchType]);

  const searchRadiusName = useMemo(() => {
    return getRadiusNameBySearchTypeAndValue({
      searchType: detail?.poiSearchType,
      radius: detail?.radius,
      minute: detail?.poiSearchMinute,
      distance: detail?.poiSearchDistance,
      rangeMode: detail?.rangeMode,
    }) || '';
  }, [detail?.poiSearchType, detail?.radius, detail?.poiSearchMinute, detail?.poiSearchDistance, detail?.rangeMode]);

  const rangeName = detail?.type === SpotTypeEnum.Street
    ? ((titleSearchTypeName || searchRadiusName) ? `${titleSearchTypeName}${searchRadiusName}` : '')
    : (radius >= 1000 ? `${fixNumber((radius / 1000), 1)}km` : `${radius}m`);

  const columns = [
    // 原户数列配置（本期移除）：dragChecked: true,
    {
      key: 'secondAoiTypeName',
      title: ` `,
      dragChecked: true,
      importWidth: true,
      width: 130,
    },
    {
      key: 'weightedHomeNumber',
      title: `加权户数(户)`,
      dragChecked: true,
      importWidth: true,
      width: 120,
    },
    {
      key: 'weightedHomeNumberRatio',
      title: `加权户数占比`,
      dragChecked: true,
      importWidth: true,
      width: 130,
      // 接口按比例返回，转为百分数展示；总计 null 按需求展示“-”。
      render: value => (value == null ? '-' : `${fixNumber(Number(value) * 100, 1)}%`),
    },
    {
      key: 'avgPrice',
      title: `平均房价(元/平方米)`,
      dragChecked: true,
      importWidth: true,
      width: 190,
    },
    {
      key: 'avgBuildYear',
      title: `加权平均建成年代`,
      dragChecked: true,
      importWidth: true,
      width: 160,
      render: value => (value == null ? '-' : fixNumber(Number(value), 1)),
    },
  ];
  const methods = useMethods({
    async loadData() {
      const params: any = {
        secondAoiTypeList: [67, 61, 62],
        lat: detail.lat,
        lng: detail.lng,
      };
      const { type, modelClusterId } = drawerData || {};
      if (type === SpotTypeEnum.Mall) {
        params.modelClusterId = modelClusterId;
        params.radius = radius; // 取接口返回的
      }
      if (type === SpotTypeEnum.Street) {
        params.poiSearchType = detail?.poiSearchType;
        params.radius = detail?.radius;
        params.poiSearchMinute = detail?.poiSearchMinute;
        params.poiSearchDistance = detail?.poiSearchDistance;
        params.points = detail?.points;
      }
      const res = await communityAgglistV2(params);
      const dataSource = toCommunityAggregateRows(res);
      return {
        dataSource,
        count: dataSource.length,
      };
    },

  });
  return (
    <Modal
      title={`${name} ${rangeName}小区汇总`}
      open={open}
      onCancel={close}
      footer={null}
      width={780}
    >
      <V2Table
        key='id'
        pagination={false}
        filters={{}}
        defaultColumns={columns}
        onFetch={methods.loadData}
        voluntarilyEmpty
        hideColumnPlaceholder
      />
    </Modal>

  );
};

export default ALQStatistics;
